// extracted by mini-css-extract-plugin
export var container = "_8z-0";
export var error = "_8z-9";
export var label = "_8z-5";
export var light = "_8z-6";
export var md = "_8z-3";
export var sm = "_8z-2";
export var thin = "_8z-8";
export var thinBold = "_8z-7";
export var vertical = "_8z-4";
export var xs = "_8z-1";